export default "__VITE_ASSET__CcTsQGqG__"